import * as i0 from '@angular/core';
import { Injectable, Inject } from '@angular/core';

class EnvironmentService {
    constructor(environmentSrc) {
        environment = environmentSrc;
    }
}
EnvironmentService.ɵfac = function EnvironmentService_Factory(t) { return new (t || EnvironmentService)(i0.ɵɵinject('environment')); };
EnvironmentService.ɵprov = i0.ɵɵdefineInjectable({ token: EnvironmentService, factory: EnvironmentService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnvironmentService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['environment']
            }] }]; }, null); })();
let environment = {
    production: null,
    baseUrl: null,
    docs: null,
    appUrl: null
};

/*
 * Public API Surface of environment-configurations
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EnvironmentService, environment };
//# sourceMappingURL=environment-configurations.js.map
